/**
 * 搜索框组件
 * @author VenDream, chenqunfeng
 * @since 18/06/07
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import VARIABLES from 'constants/variable.json5';
import Stat from '@fe/common/lib/stat';
import { sendStat, getUrlPathname, updateSearchUrlKey } from 'utils/common';
import {
  pushFiboSearchKeyWord,
  pushFiboSearchHotWord,
} from 'utils/statisticSDK';
import { isInEditorIframe } from 'utils/env';
import './searchbox.less';

const inEditorIframe = isInEditorIframe();

class SearchBox extends Component {
  static propTypes = {
    category: PropTypes.string,
    mainfigure: PropTypes.string,
    keywords: PropTypes.string,
    hotwords: PropTypes.array,
    getMainFigure: PropTypes.func,
    setSearchKeywords: PropTypes.func,
    getSearchHotwords: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      // 是否有输入值
      hasValue: false,
      // 关键词
      keywords: props.keywords,
    };
  }

  componentWillMount() {
    if (this.props.category === VARIABLES.SEARCH) {
      this.checkUrlKeywords();

      // 统计搜索结果页访问量
      sendStat(
        'RP_STORE',
        '模版市场',
        '搜索结果页-页面访问',
        Stat.ACTION_INIT,
        {
          id: 'web_mobanmarket_searchresult_preview',
        }
      );
    }
  }

  componentDidMount() {
    // 获取主题图
    this.props.getMainFigure();

    // 获取最新热词
    this.props.getSearchHotwords();

    this.applyUrlKeywords();
  }

  // 渲染热词列表
  getHotwords() {
    const { hotwords } = this.props;
    const htmls = [];

    if (!hotwords.length) {
      return '获取中...';
    }

    for (const [i, hotword] of Object.entries(hotwords)) {
      htmls.push(
        <li
          className="hotword"
          key={i}
          onClick={this.selectHotword.bind(this, hotword)}>
          {hotword}
        </li>
      );
    }

    return htmls;
  }

  // 检查URL中的keywords
  checkUrlKeywords() {
    let keywords = window.location.search.match(/keyword=([^&]*)/);
    keywords = keywords && keywords.length && keywords[1];

    keywords &&
      this.setState({ keywords: decodeURIComponent(keywords), hasValue: true });
  }

  // 应用URL中的keywords
  applyUrlKeywords() {
    // 检查是否有预设的搜索关键词
    if (this.state.keywords) {
      this.input.value = this.state.keywords;
      this.doSearch();
    }
  }

  // 检测输入
  handleInput = () => {
    const hasValue = !!this.input.value;
    this.setState({ hasValue });
  };

  // 检测快捷按键
  handleKeyDown = e => {
    // 回车
    if (e.keyCode === 13) {
      this.doSearch();
    }
  };

  // 清空搜索
  clearInput = () => {
    this.input.value = '';
    this.setState({ hasValue: false });
    // this.doSearch();
  };

  // 选择热词作为关键词
  selectHotword = hotword => {
    this.input.value = hotword;
    this.setState({ hasValue: true });
    this.doSearch();

    // 统计热词点击数据
    sendStat('RP_STORE', '模版市场', '点击搜索热词', Stat.ACTION_CLICK, {
      id: 'web_mobanmarket_hotsearch_click',
      hotword,
      clickfrom: this.props.category === VARIABLES.SEARCH ? '9' : '10',
    });
    pushFiboSearchHotWord(hotword);
  };

  // 设置搜索关键词并执行搜索动作
  doSearch = () => {
    const keywords = this.input.value;

    const pathname = getUrlPathname();

    if (pathname !== '/template/search.html') {
      // 当前为模版市场首页
      // 被嵌套在iframe中时不使用 window.open
      const keyword = 'keyword=' + keywords;
      const link = `/template/search.html${
        location.search.includes('?')
          ? location.search + '&' + keyword
          : '?' + keyword
      }`;
      if (window === window.top) {
        window.open(link);
      } else {
        window.location.href = link;
      }
    } else {
      // 更新搜索词
      updateSearchUrlKey('keyword', keywords);
      // 当前在搜索结果页
      this.props.setSearchKeywords(keywords);
    }
    if (keywords) {
      pushFiboSearchKeyWord(keywords);
    }
  };

  render() {
    const { mainfigure } = this.props;
    const style =
      (mainfigure && {
        backgroundImage: `url(${mainfigure})`,
      }) ||
      null;

    return (
      <div
        id="search-template-list-topic"
        className={classnames('cmp searchbox transitionable', {
          'in-editor-iframe': inEditorIframe,
        })}>
        <div
          className={classnames(
            'search-background',
            mainfigure && 'searchbox-show'
          )}
          style={style}
        />
        <div className="input-box">
          <input
            type="text"
            placeholder="模板多，设计师多，每天更新"
            defaultValue={this.state.keywords}
            onKeyDown={this.handleKeyDown}
            onInput={this.handleInput}
            ref={node => (this.input = node)}
            maxLength={40}
          />
          <span className="icon-box" title="搜索" onClick={this.doSearch}>
            <i className="s-icon icon-search" />
            {!inEditorIframe && <span>搜索</span>}
          </span>
          <span
            className={classnames('clear-btn', { active: this.state.hasValue })}
            title="清空"
            onClick={this.clearInput}
          />
        </div>
        {!inEditorIframe && (
          <div className="hotwords">
            <span className="hot-label">热门搜索：</span>
            <ul className="hotwords-list">{this.getHotwords()}</ul>
          </div>
        )}
      </div>
    );
  }
}

export default SearchBox;
